import { makeStyles } from "@mui/styles";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { AppColors } from "resources/AppColors";
import { dateIsValid } from "utils/HelperFunctions";
import { datePickerTexts } from "./constants";

const useStyles = makeStyles((theme) => ({
  textFieldLabel: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: AppColors.PRIMARY,
      },
    },
    "& .MuiInputBase-root": {
      color: AppColors.PRIMARY,
    },
    "& .MuiInputLabel-root": {
      color: AppColors.PRIMARY,
    },
    color: AppColors.PRIMARY,
    backgroundColor: AppColors.BOX_FILL,
  },
}));

const DatePickerNew = ({
  isExport,
  label,
  minDate,
  maxDate,
  required,
  inputRef,
  value,
  setValue,
  textfieldProps,
  ...other
}) => {
  const classes = useStyles();

  if (minDate && !dateIsValid(minDate)) throw new Error(datePickerTexts.ErrorValueMinDate)

  if (maxDate && !dateIsValid(maxDate)) throw new Error(datePickerTexts.ErrorValueMaxDate)

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        inputRef={inputRef}
        value={value}
        onChange={setValue}
        label={label}
        minDate={minDate}
        maxDate={maxDate}
        format={isExport ? datePickerTexts.MonthYearFormat : datePickerTexts.DayMonthYearFormat}
        slotProps={{
          textField: {
            className: classes.textFieldLabel,
            ...textfieldProps,
            InputLabelProps: {
              required: required
            },
            inputProps: {
              placeholder: isExport ? datePickerTexts.MonthYearFormat : datePickerTexts.DayMonthYearFormat,
            },
          },
        }}
        {...other}
      />
    </LocalizationProvider>
  );
};

export default DatePickerNew;
